// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"ddf35122","101":"93550eb3","284":"6ffcf6d3","415":"de4c70bb","424":"6556cfc2","557":"41991c8e","601":"69858e47","623":"8d0c9967","736":"5409095f","930":"f5d77de8"}[chunkId] + ".js";
};